import { render, staticRenderFns } from "./upload-input.vue?vue&type=template&id=fa656508&scoped=true&"
import script from "./upload-input.vue?vue&type=script&lang=js&"
export * from "./upload-input.vue?vue&type=script&lang=js&"
import style0 from "./upload-input.vue?vue&type=style&index=0&id=fa656508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa656508",
  null
  
)

export default component.exports